import React from 'react'
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Divider from '@material-ui/core/Divider';

import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';

import Slider from '@mui/material/Slider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { connect } from "react-redux";
import './style.css';

import { Typography } from "@mui/material";


import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Collapse from '@mui/material/Collapse';
import ExpandMore from '@mui/icons-material/ExpandMore';

import SyncIcon from '@mui/icons-material/Sync';
import InfoIcon from '@mui/icons-material/Info';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import MapTwoToneIcon from '@mui/icons-material/MapTwoTone';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

class TourSettings extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {open: MenuStatus.None}
    }

    exportToPDF(){
        this.props.closeDrawer();
        const input = document.getElementById("app");
        html2canvas(input, {logging: true, letterRendering: 1, useCORS: true}).then(canvas => {
            const imgWidth = 208;
            const imgHeight = canvas.height * imgWidth / canvas.width;
            const imgData = canvas.toDataURL('img/png');
            const pdf = new jsPDF('p','mm','a4');
            pdf.addImage(imgData,'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save("test.pdf");
        })
    }

    render(){
        return (
            <div className="drawer">
                <div className="drawer_header">
                <Box sx={{ flexGrow: 1 }} className="drawerTitleBG">
                <Grid container spacing={2}>
                <Grid item xs={2}>
                    <IconButton onClick={this.props.closeDrawer}>
                         <ChevronLeftIcon />
                    </IconButton> 
                </Grid>
                <Grid item xs={10}>
                    <h3 className="drawerTitle">
                        Tour Settings
                    </h3>
                </Grid>
                </Grid>
                </Box>
                </div>
                    <Divider />
                    
                    <TreeView
                        defaultCollapseIcon={<ExpandMoreIcon />}
                        defaultExpandIcon={<ChevronRightIcon />}
                        sx={{  flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
                        multiSelect
                    >
                        <TreeItem nodeId="1" label="Upper Window" class="treeItem">
                            {this.renderUpperOptions("1")}
                        </TreeItem>

                        {
                            (this.props.belowWindow !== undefined) && 
                            <div><Divider />
                            <TreeItem nodeId="2" label="Lower Window" class="treeItem">
                                {this.renderBelowOptions("2")}
                            </TreeItem></div> 
                        }
                    </TreeView>
                    
                    <Divider />
                    <List
                        sx={{ width: '100%', maxWidth: 360, bgcolor: '#E5E5E5' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItemButton onClick={() => this.handleMenuStatus(MenuStatus.TourSlider)}>
                            <ListItemIcon>
                            <SettingsEthernetIcon />
                            </ListItemIcon>
                            <ListItemText primary="Tour Slider" />
                            <ExpandMore />
                        </ListItemButton>
                        <Collapse in={(this.state.open === MenuStatus.TourSlider)} timeout="auto" unmountOnExit
                            {...((this.state.open === MenuStatus.TourSlider) ? { timeout: 1000 } : {})}
                        >
                        <Box
                            sx={{
                                width: 250,
                                height: 160,
                                justifyContent: 'center',
                                display: 'flex',
                                p: 1,
                            }}
                        >
                            <Slider
                                disabled={(this.props.belowWindow === undefined)}
                                orientation="vertical"
                                defaultValue={this.props.tourSliderValue}
                                aria-labelledby="vertical-slider"
                                size="small"
                                onChange={(event, newValue) => {
                                    this.props.setTourSlider(newValue);
                                }}
                                sx={{
                                    color: '#14213D',
                                }}
                            /> 
                       </Box>
                        </Collapse>

                        <ListItemButton onClick={() => this.handleMenuStatus(MenuStatus.MapSlider)}>
                            <ListItemIcon>
                            <SettingsEthernetIcon />
                            </ListItemIcon>
                            <ListItemText primary="Map Slider" />
                            <ExpandMore />
                        </ListItemButton>
                        <Collapse in={(this.state.open === MenuStatus.MapSlider)} timeout="auto" unmountOnExit
                            {...((this.state.open === MenuStatus.MapSlider) ? { timeout: 1000 } : {})}
                        >
                        {/* <div class="mapSlider"> */}
                        <Box
                            sx={{
                                width: 295,
                                height: 160,
                                alignContent: 'center',
                                flexWrap: 'wrap',
                                display: 'flex',
                                p: 1,
                            }}
                        >
                            <Slider
                                orientation="horizontal"
                                defaultValue={this.props.mapSliderValue}
                                size="small"
                                step={10} 
                                marks 
                                min={30} 
                                max={100}
                                aria-labelledby="horizontal-slider"
                                onChange={(event, newValue) => {
                                    this.props.setMapSlider(newValue);
                                }}
                                sx={{
                                    color: '#14213D',
                                }}
                            /> 
                        </Box>
                        {/* </div> */}
                        </Collapse>

                        <ListItemButton onClick={() => this.handleMenuStatus(MenuStatus.Sync)}>
                            <ListItemIcon>
                            <SyncIcon />
                            </ListItemIcon>
                            <ListItemText primary="Sync Views" />
                            <Switch
                                disabled={(this.props.belowWindow === undefined)}
                                edge="end"
                                onChange={() => this.props.setSync(this.props.syncViews)}
                                checked={this.props.syncViews}
                                inputProps={{
                                    'aria-labelledby': 'switch-list-label-synchronization',
                                }}
                            />
                        </ListItemButton>
                        <ListItemButton onClick={() => this.handleMenuStatus(MenuStatus.Map)}>
                            <ListItemIcon>
                            <MapTwoToneIcon />
                            </ListItemIcon>
                            <ListItemText primary="Map" />
                            <Switch
                                edge="end"
                                onChange={() => this.props.setMap(this.props.map)}
                                checked={this.props.map}
                                inputProps={{
                                    'aria-labelledby': 'switch-list-label-synchronization',
                                }}
                            />
                        </ListItemButton>
                        <ListItemButton onClick={() => this.props.setInfoDialog(true)}>
                            <ListItemIcon>
                            <InfoIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Info" />
                        </ListItemButton>
                        {/* <ListItemButton onClick={() => this.exportToPDF()}>
                            <ListItemIcon>
                            <FileDownloadIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Export to PDF" />
                        </ListItemButton> */}
                    </List>
                    <div className={"drawer_foot"}>
                        <Box
                            component="img"
                            sx={{
                                height: 50,
                                width: 50,
                            }}
                            alt="Hawkeye Image"
                            src={process.env.PUBLIC_URL+"/hawkeye_logo.png"}
                        />
                        <Typography>
                            Version 1.0.0
                        </Typography>
                        <Typography>
                            Copyright ® 2023
                        </Typography>
                    </div>
            </div>
        );
    }


    handleMenuStatus(newValue){
        if(this.state.open === newValue){
            this.setState({open : MenuStatus.None});
        }else{
            this.setState({open : newValue});
        }
    }

    renderUpperOptions(id){
        return this.props.tours.sort(function(a,b){
            var numberA = parseInt(a.split('-').reverse().join(''));
            var numberB = parseInt(b.split('-').reverse().join(''));
            return numberB - numberA;
          }).map(item =>
            <TreeItem nodeId={item.id} label={item} onClick={() => this.props.setUpper(this.props.tourName + "/" + item)}>
            </TreeItem>
        )
    }

    renderBelowOptions(id){
        return this.props.tours.sort(function(a,b){
            var numberA = parseInt(a.split('-').reverse().join(''));
            var numberB = parseInt(b.split('-').reverse().join(''));
            return numberB - numberA;
          }).map(item =>
            <TreeItem nodeId={item.id} label={item} onClick={() => this.props.setBelow(this.props.tourName + "/" + item)}>
            </TreeItem>
        )
    }
}

const  MenuStatus = {
    Tours : 0, 
    TourSlider : 1,
    MapSlider: 2,
    Sync : 3,
    Map: 4,
    Info: 5,
    None : 6
}
  
const mapDispatchToProps = dispatch => ({
    setUpper: (tourWin) => dispatch({type: "update/upperWindow", tour: tourWin}),
    setBelow: (tourWin) => dispatch({type: "update/belowWindow", tour: tourWin}),
    setTourSlider : (sliderVal) => dispatch({type: "update/tourSlider", tourSliderValue: sliderVal}),
    setMapSlider : (sliderVal) => dispatch({type: "update/mapSlider", mapSliderValue: sliderVal}),
    setSync : (syncViews) => dispatch({type: "update/syncViews", syncViews: syncViews}),
    setMap : (map) => dispatch({type: "openclose/map", map: map}),
    setInfoDialog : (infoDialog) => dispatch({type: "update/infoDialog", infoDialog: infoDialog}) 
});

const mapStateToProps = state => ({
    syncViews : state.syncViews,
    map : state.map,
    mapSliderValue : state.mapSliderValue,
    tourSliderValue : state.tourSliderValue,
    upperWindow: state.upperWindow,
    belowWindow: state.belowWindow,
    infoDialog: state.infoDialog,
    tours: state.tours,
    tourName : state.tourName,
});

export default connect(mapStateToProps, mapDispatchToProps)(TourSettings);


